import React from 'react';

interface WorkflowCardProps {
  title?: string;
  subtitle?: string;
  icon?: React.ReactNode;
  actions?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  noPadding?: boolean;
  compact?: boolean;
}

export const WorkflowCard: React.FC<WorkflowCardProps> = ({
  title,
  subtitle,
  icon,
  actions,
  children,
  className = '',
  noPadding = false,
  compact = false
}) => {
  const hasHeader = title || subtitle || icon || actions;

  return (
    <div className={`
      bg-white dark:bg-dark-surface rounded-xl
      border border-gray-200 dark:border-dark-border
      shadow-sm dark:shadow-dark-lg
      ${className}
    `}>
      {hasHeader && (
        <div className={`
          ${compact ? 'px-4 py-3' : 'px-5 py-4'}
          border-b border-gray-200 dark:border-dark-border
          flex items-center justify-between
        `}>
          <div className="flex items-center gap-3">
            {icon && (
              <div className="p-2 bg-primary-50 dark:bg-primary-900/30 text-primary-600 dark:text-primary-400 rounded-lg">
                {icon}
              </div>
            )}
            <div>
              {title && (
                <h3 className="text-base font-semibold text-gray-900 dark:text-white">
                  {title}
                </h3>
              )}
              {subtitle && (
                <p className="text-sm text-gray-500 dark:text-gray-400 mt-0.5">
                  {subtitle}
                </p>
              )}
            </div>
          </div>
          {actions && (
            <div className="flex items-center gap-2">
              {actions}
            </div>
          )}
        </div>
      )}
      <div className={noPadding ? '' : compact ? 'p-4' : 'p-5'}>
        {children}
      </div>
    </div>
  );
};
